export default "__VITE_ASSET__DDvCanLm__"